import type { ApiQuestionSetting } from '../../../../internalTypes/apiQuestionSetting';

export function detectMatrixFormat(configs: ApiQuestionSetting[]): 'standard' | 'carousel' | 'dropdown' {
  const configsString = JSON.stringify(configs).toUpperCase();
  if (configsString.includes('CAROUSEL')) return 'carousel';
  if (configsString.includes('DROPDOWN')) return 'dropdown';
  return 'standard';
}
